import React from 'react'
import _ from 'lodash'
import PropTypes from 'prop-types'
import { alphabetizeByKey } from '../util.js'
import NgssContentTag from './NgssContentTag'

const NgssTagGroup = ({ size, objectWithNgssTags }) => {
  const tagFor = item => item.length > 31 ? `${item.substring(0,15)}...${item.substring(item.length-16, item.length)}` : item
  return(
    <div className='ngss-tag-group'>
      {!_.isEmpty(objectWithNgssTags.ngssPes) && _.map(_.orderBy(objectWithNgssTags.ngssPes, 'code'), (pe, id)=> {
        return(<NgssContentTag key={`pe-${id}`} text={pe.code} type='ngss-pes' size={size || 'medium'}/>)
      })}
      {!_.isEmpty(objectWithNgssTags.ngssDcis) && _.map(alphabetizeByKey(objectWithNgssTags.ngssDcis), (clauses,dimension)=>
        <NgssContentTag key={dimension} title={dimension} text={tagFor(dimension)} type='ngss-dcis' size={size || 'medium'}/>
      )}
      {!_.isEmpty(objectWithNgssTags.ngssSeps) && _.map(alphabetizeByKey(objectWithNgssTags.ngssSeps), (clauses,dimension)=>
        <NgssContentTag key={dimension} title={dimension} text={tagFor(dimension)} type='ngss-seps' size={size || 'medium'}/>
      )}
      {!_.isEmpty(objectWithNgssTags.ngssCccs) && _.map(alphabetizeByKey(objectWithNgssTags.ngssCccs), (clauses,dimension)=>
        <NgssContentTag key={dimension} title={dimension} text={tagFor(dimension)} type='ngss-cccs' size={size || 'medium'}/>
      )}
    </div>
  )
}

NgssTagGroup.propTypes = {
  objectWithNgssTags: PropTypes.object.isRequired
}

export default NgssTagGroup
